import React from "react";
// import Navbar from "../../components/Navbar/navbar";

import Welcome from "../../components/proofer-tool-cmps/welcome/welcome";
import ProoferDashboard from "./dashboard/dashboard";

function ProoferTool() {
    return (
        <>
            <ProoferDashboard />
        </>
    );
}

export default ProoferTool;
